var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgNoResultscolor = function SvgNoResultscolor(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.858 28.315c5.981 5.98 15.393 6.44 21.9 1.375l9.703 9.703a2.073 2.073 0 1 0 2.932-2.932l-9.703-9.703c5.064-6.507 4.606-15.919-1.375-21.9-6.478-6.477-16.98-6.477-23.457 0s-6.477 16.98 0 23.457Zm2.932-2.932c-4.858-4.858-4.858-12.735 0-17.593 4.858-4.858 12.735-4.858 17.593 0 4.858 4.858 4.858 12.735 0 17.593-4.858 4.858-12.735 4.858-17.593 0Z",
    fill: "#5C7783"
  })));
};
export default SvgNoResultscolor;